<template>
  <div>
    <span class="question-style">
      {{ question && question.no }}.
      <span class="ml-2" v-html="overrideQuestion(question && question.content)"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'QuestionItem',
  props: {
    question: {
      type: Object,
      required: true
    },
    typeQuestion: {
      type: String,
      required: true
    }
  },
  methods: {
    overrideQuestion(content) {
      if (content) {
        return content.replace(/##/g, '___')
      }
      return ''
    }
  }
}
</script>

<style scoped>
.question-style {
  display: flex;
  align-items: flex-start;
}

::v-deep(.question-style table tr) {
  border: none !important;
}

::v-deep(.question-style table td) {
  padding: 0 !important;
  margin: 0 !important;
}

.ml-2 {
  margin-left: 8px;
}
</style>